import axios from 'axios';
import store from './store/index';

export default function interceptors() {
  axios.interceptors.request.use((request) => {
    const csrf = document.querySelector('[name="_csrf"]');
    const csrfHeader = document.querySelector('[name="_csrf_header"]');
    if (csrf && csrfHeader) {
      request.headers['X-CSRF-TOKEN'] = `${csrf.content}`;
    }
    return request;
  });

  axios.interceptors.response.use(
    (response) => {
      if (response?.headers['feature-model']) {
        const featureModel = JSON.parse(response.headers['feature-model']);
        store.dispatch('setFeatureModel', featureModel);
      }
      return response;
    },
    (error) => {
      if (axios.isCancel(error)) {
        return Promise.reject(error);
      }
      if (error.response?.status === 422) {
        if (error.response.data.errors) {
          store.dispatch('setFormErrors', {
            formName: error.response.config.formName,
            errorResponse: error.response.data.errors
          });
        } else {
          store.dispatch('setFormErrors', {
            formName: error.response.config.formName,
            errorResponse: [
              {
                field: error.response.data.field,
                message: error.response.data.message
              }
            ]
          });
        }
      }
      return Promise.reject(error);
    }
  );
}
